// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-2b53520a","scoped":true,"hasInlineConfig":false}!./src/components/nudge-console/nudge-console-theme.css
// module id = frDV
// module chunks = 1